export const APPLICATION_LOCAL_STORAGE_KEY = "applicationFormSavedInfo";
export const USER_LAST_ACTIVITY = "user_last_activity";
export const TEMPORARY_PROPERTIES_FILTERS = "temporaryPropertiesFilters";
export const IS_COOKIE_MESSAGE_READ_LS_KEY = "cookieMessageIsRead";
export const SENT_APPLICATIONS = "sentApplications";
export const SENT_PROPERTY_APPLICATIONS = "sentPropertyApplications";
export const FAVOURITE_LOCAL_STORAGE_KEY_V2 = "favourite_storage_v2";
export const FAVOURITE_LOCAL_STORAGE_KEY_V3 = "favourite_storage_v3";
export const IS_FAVOURITES_MODAL_CLOSED = "favouritesModalClosed";
export const PROPERTY_CONFIGURATOR_VALUES = "propertyConfiguratorValues";
export const PROPERTY_CONFIGURATOR_LOCATION = "propertyConfiguratorLocation";
export const MID_LISTING_LAST_BANNER_TYPE = "midListingLastBannerType";
export const USER_LAST_SEEN_OFFER_PROPERTIES = "userLastSeenOfferProperties";
export const ARTICLE_ATTACHMENT_LS_KEY = "articleAttachment";

export const USER_REEL_PLAYER_SETTINGS = "userReelPlayerSettings";
export const USER_REEL_STATS = "userReelStats";
export const ASKED_ABOUT_LOCATION = "askedAboutLocation";
export const SENT_PREFERENCES_WITH_APPLICATION = "sentPreferencesWithApplication";
export const HOME_MATCH_PREFERENCES_SESSION_KEY = "homeMatchPreferencesSession";
export const HOME_MATCH_PENDING_PREFERENCES_KEY = "homeMatchPendingPreferences";
export const CREDIT_OFFERS_UNLOCKED = "creditOffersUnlocked";
export const HOTLINE_MODAL_CLOSED_KEY = "hotline_modal_closed";
export const NEWSLETTER_SEARCH_DATA_STORAGE_KEY = "newsletterSearchData";
export const HOTLINE_LISTING_POPUP_SEEN = "hotlineListingPopUpSeen";
export const RP_TURNSTILE_SIMULATION_STORAGE_KEY = "rpTurnstileSimulation";
export const SEEN_OFFERS_MAP_KEY = "seenOffersMap";
export const APPLICATION_LOCAL_STORAGE_KEY = "applicationFormSavedInfo";
export const USER_LAST_ACTIVITY = "user_last_activity";
export const TEMPORARY_PROPERTIES_FILTERS = "temporaryPropertiesFilters";
export const IS_COOKIE_MESSAGE_READ_LS_KEY = "cookieMessageIsRead";
export const SENT_APPLICATIONS = "sentApplications";
export const SENT_PROPERTY_APPLICATIONS = "sentPropertyApplications";
export const FAVOURITE_LOCAL_STORAGE_KEY_V2 = "favourite_storage_v2";
export const FAVOURITE_LOCAL_STORAGE_KEY_V3 = "favourite_storage_v3";
export const IS_FAVOURITES_MODAL_CLOSED = "favouritesModalClosed";
export const PROPERTY_CONFIGURATOR_VALUES = "propertyConfiguratorValues";
export const PROPERTY_CONFIGURATOR_LOCATION = "propertyConfiguratorLocation";
export const MID_LISTING_LAST_BANNER_TYPE = "midListingLastBannerType";
export const USER_LAST_SEEN_OFFER_PROPERTIES = "userLastSeenOfferProperties";
export const ARTICLE_ATTACHMENT_LS_KEY = "articleAttachment";

export const USER_REEL_PLAYER_SETTINGS = "userReelPlayerSettings";
export const USER_REEL_STATS = "userReelStats";
export const ASKED_ABOUT_LOCATION = "askedAboutLocation";
export const SENT_PREFERENCES_WITH_APPLICATION = "sentPreferencesWithApplication";
export const HOME_MATCH_PREFERENCES_SESSION_KEY = "homeMatchPreferencesSession";
export const HOME_MATCH_PENDING_PREFERENCES_KEY = "homeMatchPendingPreferences";
export const CREDIT_OFFERS_UNLOCKED = "creditOffersUnlocked";
export const HOTLINE_MODAL_CLOSED_KEY = "hotline_modal_closed";
export const NEWSLETTER_SEARCH_DATA_STORAGE_KEY = "newsletterSearchData";
export const HOTLINE_LISTING_POPUP_SEEN = "hotlineListingPopUpSeen";
export const RP_TURNSTILE_SIMULATION_STORAGE_KEY = "rpTurnstileSimulation";
export const SEEN_OFFERS_MAP_KEY = "seenOffersMap";
